// Normalize a movie's poster_path for display. Returns a usable src, or null so
// the caller falls back to the Film Revival NYC icon.
//
// Why: 134 movies rows store poster_path as the literal string "none" (curated
// records, placeholders, cartoon/kids programs, secret screenings). "none" is
// truthy, so a plain `poster_path ? <img src=poster_path> : <fallback>` renders
// `<img src="none">` — a broken-image icon. Treat "none"/"null"/"undefined"/empty
// as no-poster everywhere poster_path feeds an <img>.
export const posterSrc = (p) => {
  const s = (p == null ? '' : String(p)).trim().toLowerCase();
  return (!s || s === 'none' || s === 'null' || s === 'undefined') ? null : p;
};
